import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "../slide.js";
import Multifle_Study from "../img/Multifle_Study.png";
import Crow_img_2 from "../img/Crow/1.png";
import AI_1 from "../img/AI_1.png";
import AI_2_1 from "../img/AI_2_1.png";
import AI_2_2 from "../img/AI_2_2.png";
import AI_3 from "../img/AI_3.png";
import Video from "../img/video_test.mp4";
function Studies_list(){
    return(
        <Wrapper_div>
            <Title_span>Multicenter Studies</Title_span>
            <Content_p>AIDU lab serves as central coordinating center and system provider for many multicenter registries or prospective cohorts.</Content_p>
            <UL>
                <LI><Point_span/><Title_span_T>KRoCS RCC DB</Title_span_T></LI>
                    <LI> Korean Renal Cancer Study Group (KRoCS) renal cell carcinoma (RCC) database is a nation-wide, multicenter, prospectively collected, retrospective data registry for pathologically proven RCC patients who underwent radical or partial nephrectomy. The Korean Urological Oncology Society initiated the data registry and 15 representative, high-volume academic tertiary institutions participate KRoCS RCC DB. 
                    </LI>
                <LI><Point_span/><Title_span_T>KUOS multicenter, prospective prostate cancer AS cohort</Title_span_T></LI>
                    <LI>This is a nation-wide, multicenter, prospective registry initiated by the Korean Urological Oncology Society for prostate cancer active surveillance patients. A total of 14 representative, high-volume academic hospitals participate and more than 500 patients have been enrolled since 2019. 
                    </LI>
                <LI><Point_span/><Title_span_T>KUOS multicenter, prospective metastatic prostate cancer cohort</Title_span_T></LI>
                    <LI>This is a nation-wide, multicenter, prospective cohort for histologically proven metastatic prostate cancer maintained by the Korean Urological Oncology Society. A total of 14 representative, high-volume academic hospitals participate and more than 270 patients have been enrolled since 2019.
                    </LI>
            </UL>
        </Wrapper_div>
    )
}
const Title_span_T = styled.span`
    font-weight: bold;
    color: #212121;
    font-size : 20px;
`

function Multicenter_studies(){
    return (
        <Wrapper>
            <Slide imgURL={Multifle_Study} inputText="Multicenter studies"/>
            <Studies_list/>
            <Crow_img2 src={Crow_img_2}/>
        </Wrapper>
    )
}  

const Wrapper = styled.div`
font-family: "En";        
position : relative; 
top : 90px;
width : 1200px; 
margin : 0 auto; 
font-size : 20px;
`
const Title_span = styled.span`
font-family: "Title";        
    display : inline-block;
    font-size : 35px; 
    font-weight : bold;
    margin-top :70px ;
`
const Content_p = styled.p`
font-family: "Content";        
    margin : 20px 0 ; 
    font-size : 20px; 
    color : #212121;

`
const Wrapper_div = styled.div`
    margin : 0 10%;
    margin-bottom : 70px;
`
const UL = styled.ul`
    margin : 40px 0  ;

`
const LI = styled.li`
    margin : 0;
    padding : 10px 40px;
    font-size : 20px;
    line-height : 30px;
    color : #212121;
    &:nth-child(2n){
        background:#F9F9F9;
        padding-left : 65px; 
        font-family: "Table_content";        
    }
    &:nth-child(2n-1){
        background:#E4F3FF;
        font-family: "Table_title";        
    }
`
const Point_span = styled.span`
    background-color :#32A4FF;
    width : 5px; 
    height : 5px; 
    line-height : 25px;
    display : inline-block; 
    border-radius : 100%;
    vertical-align : middle;
    margin : 0 10px;
`
const Crow_img2 = styled.img`
width : 150px; 
height : 149px;
position : absolute;
bottom:-80px;
right : 100px;
`
export default Multicenter_studies;